import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Hero from "../../components/Hero";
import SingleProductImg from "../../images/singleProductBcg.jpeg";
import { ProductConsumer } from "../../context";

export default class AdminProductUpdate extends Component {
  render() {
    return (
      <>
        <Hero img={SingleProductImg} title="Rediger Produkt" />
        <ProductConsumer>
          {(value) => {
            const {
              handleChange,
              singleProduct,
              updateProduct,
              loading,
              productprice,
              productNr,
              productName,
              productTopping,
              price,
              price1,
              price2,
              menu,
              haslogged,
            } = value;
            const sorteredeCat = () => {
              switch (singleProduct.category) {
                case "Klassisk PIZZA":
                case "Special PIZZA":
                case "Mexican PIZZA":
                case "Vegetar PIZZA":
                case "Indbagt PIZZA":
                  return (
                    <div className="col-10 mx-auto col-sm8 col-md-6 my-3">
                      <h5 className="text-title mb-4">
                        {productNr}. {productName} pris: {productprice}
                      </h5>
                      <h5 className="text-capitalize text-muted mb-4">
                        {productTopping}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Almindelig: kr {price}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Deeppan: kr {price1}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Familie: kr {price2}
                      </h5>
                      <Link
                        to="/admin"
                        type="button"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                        onClick={() => updateProduct(singleProduct)}
                      >
                        Rediger
                      </Link>
                      <Link
                        to="/admin"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                      >
                        Tilbage til Kontrolpanel
                      </Link>
                    </div>
                  );

                case "Burgers":
                  return (
                    <div className="col-10 mx-auto col-sm8 col-md-6 my-3">
                      <h5 className="text-title mb-4">
                        {productNr}. {productName} pris: {productprice}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Almindelig: kr {price}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Hjemmelavet: kr {price1}
                      </h5>
                      <Link
                        to="/admin"
                        type="button"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                        onClick={() => updateProduct(singleProduct)}
                      >
                        Rediger
                      </Link>
                      <Link
                        to="/admin"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                      >
                        Tilbage til Kontrolpanel
                      </Link>
                    </div>
                  );
                case "Pasta":
                case "Hvidløgsbrød":
                case "Salat":
                case "Hjemmelavet Pizza Sandwich":
                case "Durum Rulle":
                case "Børne Menu":
                case "Diverse":
                case "Drikkevare":
                case "Pita Brød":
                case "Menuer":
                case "À la carte":
                  return (
                    <div className="col-10 mx-auto col-sm8 col-md-6 my-3">
                      <h5 className="text-title mb-4">
                        {productNr}. {productName} pris: {productprice}
                      </h5>
                      <h5 className="text-capitalize text-muted mb-4">
                        {productTopping}
                      </h5>
                      <h5 className="text-capitalize text-main mb-4">
                        Portion: kr {price}
                      </h5>
                      <Link
                        to="/admin"
                        type="button"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                        onClick={() => updateProduct(singleProduct)}
                      >
                        Rediger
                      </Link>
                      <Link
                        to="/admin"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                      >
                        Tilbage til Kontrolpanel
                      </Link>
                    </div>
                  );
                default:
                  break;
              }
            };

            const sortedRediger = () => {
              switch (singleProduct.category) {
                case "Klassisk PIZZA":
                case "Special PIZZA":
                case "Mexican PIZZA":
                case "Vegetar PIZZA":
                case "Indbagt PIZZA":
                  return (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            id="price"
                            min="1"
                            max="999"
                            name="price"
                            className="form-control"
                            onChange={handleChange}
                            value={price}
                          />
                          <label htmlFor="price" className="">
                            Almindelig
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            id="price1"
                            min="1"
                            max="999"
                            name="price1"
                            className="form-control"
                            onChange={handleChange}
                            value={price1}
                          />
                          <label htmlFor="price1" className="">
                            Deep
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            min="1"
                            max="999"
                            id="price2"
                            name="price2"
                            className="form-control"
                            onChange={handleChange}
                            value={price2}
                          />
                          <label htmlFor="price2" className="">
                            Familie
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="text"
                            id="productTopping"
                            name="productTopping"
                            className="form-control"
                            onChange={handleChange}
                            value={productTopping}
                          />
                          <label htmlFor="productTopping" className="">
                            Topping
                          </label>
                        </div>
                      </div>
                    </div>
                  );

                case "Burgers":
                  return (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            id="price"
                            min="1"
                            max="999"
                            name="price"
                            className="form-control"
                            onChange={handleChange}
                            value={price}
                          />
                          <label htmlFor="price" className="">
                            Almindelig
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            id="price1"
                            min="1"
                            max="999"
                            name="price1"
                            className="form-control"
                            onChange={handleChange}
                            value={price1}
                          />
                          <label htmlFor="price1" className="">
                            Hjemmelavet
                          </label>
                        </div>
                      </div>
                    </div>
                  );

                case "Pasta":
                case "Hvidløgsbrød":
                case "Salat":
                case "Hjemmelavet Pizza Sandwich":
                case "Durum Rulle":
                case "Børne Menu":
                case "Diverse":
                case "Drikkevare":
                case "Pita Brød":
                case "Menuer":
                case "À la carte":
                  return (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="number"
                            id="price"
                            min="1"
                            max="999"
                            name="price"
                            className="form-control"
                            onChange={handleChange}
                            value={price}
                          />
                          <label htmlFor="price" className="">
                            Portion
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            type="text"
                            id="productTopping"
                            name="productTopping"
                            className="form-control"
                            onChange={handleChange}
                            value={productTopping}
                          />
                          <label htmlFor="productTopping" className="">
                            Topping
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                default:
                  break;
              }
            };

            if (haslogged) {
              let companies = new Set();
              for (let product in menu) {
                companies.add(menu[product]["category"]);
              }
              companies = [...companies];
              if (loading) {
                return <h1>product loading..</h1>;
              }
              return (
                <section className="py-5">
                  <div className="contanier">
                    <div className="row ml-3">
                      <div className="col-10 mx-auto col-sm-8 col-md-6 my-3">
                        <form id="contact-form" method="POST">
                          <div>
                            <label htmlFor="kategorie">Kategori</label>
                            <select
                              name="category"
                              id="category"
                              className="filter-item"
                              onChange={handleChange}
                              value={singleProduct.category}
                            >
                              {companies.map((category, index) => {
                                return (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="md-form mb-0">
                                <input
                                  type="number"
                                  min="1"
                                  max="999"
                                  id="productNr"
                                  name="productNr"
                                  className="form-control"
                                  onChange={handleChange}
                                  value={productNr}
                                />
                                <label htmlFor="productNr" className="">
                                  Nr
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="md-form mb-0">
                                <input
                                  type="text"
                                  id="productName"
                                  name="productName"
                                  className="form-control"
                                  onChange={handleChange}
                                  value={productName}
                                />
                                <label htmlFor="productName" className="">
                                  Navn
                                </label>
                              </div>
                            </div>
                          </div>
                          {sortedRediger()}
                        </form>
                      </div>
                      {sorteredeCat()}
                    </div>
                  </div>
                </section>
              );
            } else {
              return <Redirect to="/admin" />;
            }
          }}
        </ProductConsumer>
      </>
    );
  }
}
